import { Icon, IconProps } from '@chakra-ui/react';

export const ProductIcon = (props: IconProps) => (
  <Icon width='23px' height='24px' viewBox='0 0 23 24' fill='none' {...props}>
    <path
      d='M21.367 7.06649L11.5002 2.13306L1.6333 7.06649V16.9334L11.5002 21.8668L21.367 16.9334V7.06649Z'
      stroke='black'
      strokeWidth='1.97337'
      strokeLinejoin='round'
    />
    <path
      d='M1.6333 7.06665L11.5002 12.0001'
      stroke='black'
      strokeWidth='1.97337'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M11.5 21.8669V12' stroke='black' strokeWidth='1.97337' strokeLinecap='round' strokeLinejoin='round' />
    <path
      d='M21.3669 7.06665L11.5 12.0001'
      stroke='black'
      strokeWidth='1.97337'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M16.4338 4.59985L6.56689 9.53329'
      stroke='black'
      strokeWidth='1.97337'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Icon>
);
